module.exports = __webpack_public_path__ + "static/media/Transfer.5869e2da.svg";